import { TYPES } from '../actions';

const initialState = {
  permissions: [],
  loading: false,
  error: null
};

export const permissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ACTION_GET_PERMISSIONS_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };
    case TYPES.ACTION_GET_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissions: action.payload.data,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_PERMISSIONS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}; 